export default __webpack_public_path__ + "static/media/filledArrow.2e40f731.svg";